import React from 'react'
import { Redirect } from 'react-router-dom'

/**
 * Legacy Sentinel result page. In Sentinel v2 the customer drill-down opens
 * inline in the conversation-level inspector, so this standalone page is
 * retired — the route redirects to the chat to keep old deep links working.
 */
export default function SentinelResultPage() {
  return <Redirect to="/sentinel" />
}
